import React from 'react';

import { useTranslation } from 'hooks/useTranslation';
import { Input } from 'components';

import styles from './AddMember.module.scss';

interface AddMemberProps {
  organizationUrl: string;
  signupDomain: string;
}
export const AddMember: React.FC<AddMemberProps> = ({ organizationUrl, signupDomain }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.upper}>
        <div className={styles.heading}>
          {t('settings-screen.members.add-member-popup.heading')}
        </div>

        <Input copyOnly value={organizationUrl} />
      </div>

      <div className={styles.lower}>
        {t('settings-screen.members.add-member-popup.only')}{' '}
        <span className={styles.strong}>{signupDomain}</span>{' '}
        {t('settings-screen.members.add-member-popup.only-domains')}
      </div>
    </div>
  );
};
